var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchLeafIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#28384C",
    d: "M6 3.903h6v1.951H6zM0 4.878L6 0v9.756L0 4.878zM14 11.708H8V9.757h6zM20 10.732l-6 4.878V5.854l6 4.878z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNiIgeT0iMy45MDI1OSIgd2lkdGg9IjYiIGhlaWdodD0iMS45NTEyMiIgZmlsbD0iIzI4Mzg0QyIvPgo8cGF0aCBkPSJNNS45NjI1ZS0wOCA0Ljg3ODAxTDYgNS43OTE4NWUtMDZMNiA5Ljc1NjFMNS45NjI1ZS0wOCA0Ljg3ODAxWiIgZmlsbD0iIzI4Mzg0QyIvPgo8cmVjdCB4PSIxNCIgeT0iMTEuNzA3MyIgd2lkdGg9IjYiIGhlaWdodD0iMS45NTEyMiIgdHJhbnNmb3JtPSJyb3RhdGUoLTE4MCAxNCAxMS43MDczKSIgZmlsbD0iIzI4Mzg0QyIvPgo8cGF0aCBkPSJNMjAgMTAuNzMxOUwxNCAxNS42MDk5TDE0IDUuODUzNzZMMjAgMTAuNzMxOVoiIGZpbGw9IiMyODM4NEMiLz4KPC9zdmc+Cg==";
export { SvgSwitchLeafIcon as ReactComponent };